import { Component, Inject, Input, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { EmailListService } from 'src/app/services/emaillist.service';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-emailing',
  templateUrl: './emailing.component.html',
  styleUrls: ['./emailing.component.scss'],
})
export class EmailingComponent implements OnInit {
  // ngModel-----------------------------------------------
  // @Input() data: any;
  data: any;
  // ngModel-----------------------------------------------

  companyId: any;

  constructor(
    // public dialogRef: MatDialogRef<EmailingComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private maillistService: EmailListService,
    private storage: Storage
  ) {
    // this.companyId = this.storage.get('company_id').then(x => {
    //   if (!this.data) {
    //     this.data = {
    //       name: "",
    //       emails: [],
    //       company: this.companyId
    //     }
    //   }
    // });
    // this.maillistService.maillistDataSubject.subscribe(x => {
    //   this.data = x;
    //   console.log("MAILLIST: ", x);
    // });
  }

  async ngOnInit() {

  }

  trackEditList(index, item) {
    return index;
  }

  addEmail() {
    this.data.emails.push("");
  }

  save() {
    
  }

  deleteEmail(email: string) {
    this.data.emails.splice(this.data.emails.findIndex(mail => mail === email), 1);
  }

}
